import { styled } from '~/styled'

export const DrawerFooter = styled('div', {
  base: ['p-4', 'w-full', 'border-t', 'border-t-(--base-3)']
})
